import { ENDPOINTS } from "@constants";
import axios from "axios";
import config from "@config";
import { AcGetState } from "@asdf-utils";
import { KEYS } from "@asdf-constants";

const NoAuthClient = axios.create({
  ...config.api_no_auth,
});

const NoBaseClient = axios.create({ ...config.api_no_base });

export const AuthAPI = {
  ping: (uri: string) => {
    return NoBaseClient.get(uri);
  },
  activate_account: (data) => {
    return NoAuthClient.post(ENDPOINTS.AUTH.ACTIVATE_ACCOUNT, data).then(
      (response) => response.data
    );
  },
  reset_password: (data) => {
    return NoAuthClient.post(ENDPOINTS.AUTH.RESET_PASSWORD, data).then(
      (response) => response.data
    );
  },
  forgot_password: (data) => {
    return NoAuthClient.post(ENDPOINTS.AUTH.FORGOT_PASSWORD, data).then(
      (response) => response.data
    );
  },
  login: (data) => {
    return NoAuthClient.post(ENDPOINTS.AUTH.LOGIN, data).then(
      (response) => response.data
    );
  },
  logout: async () => {
    const token = AcGetState(KEYS.ACCESS_TOKEN);
    return fetch(
      `${config.pkce.accounts_uri}${ENDPOINTS.AUTH.LOGOUT}`,
      {
        method: "delete",
        credentials: "include",
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );
  },
  csrf: () => {
    return NoAuthClient.get(ENDPOINTS.AUTH.CSRF);
  },
};
